// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.


export const domainArchiveDto = {
    archived: 'archived',
} as const;

export type TDomainArchiveDto = (typeof domainArchiveDto)[keyof typeof domainArchiveDto];

export interface IDomainArchiveDto {
    [domainArchiveDto.archived]: boolean | null;
}

export class DomainArchiveDto
    implements IDomainArchiveDto
{
    [domainArchiveDto.archived]: boolean | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IDomainArchiveData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[domainArchiveDto.guid] = modelData[domainarchiveData.guid];
    }

    static create(modelData?: any | null): IDomainArchiveDto | null {
        return modelData ? new DomainArchiveDto(modelData) : null;
    }
}
